import { render } from "./AlertDialog.vue?vue&type=template&id=270d5c46&ts=true"
import script from "./AlertDialog.vue?vue&type=script&lang=ts"
export * from "./AlertDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__